import xolor from "xolor";
import tinycolor from "tinycolor2";

export function colorToString(color){
  if(!color){
    return "inherit";
  }

  return `rgba(${color.r}, ${color.g}, ${color.b}, ${color.a})`;
}

export function extractBackgroundColorFromElement(element){
  if(!element){
    return null;
  }

  if(element.tagName !== 'SPAN'){
    const child = element.querySelector(':first-child');
    return extractBackgroundColorFromElement(child);
  }

  var background = window.getComputedStyle(element, null).getPropertyValue('background-color');
  if(background){
    background = parseColor(background);
  }

  if(!background){
    
  }
  
  return background;
}

export function parseColor(value){
  if(!value){
    return null;
  }

  const color = xolor(value);
  if(color.a === 0){
    return null;
  }

  return {
    type: 'solid',
    r: color.r,
    g: color.g,
    b: color.b,
    a: color.a
  }
}

export function parseGradientColor(value){
  if(!value){
    return null;
  }

  const color = tinycolor(value);

  return {
    r: color._r,
    g: color._g,
    b: color._b,
    a: color._a
  }
}

export const rgbaToHex = (color) => {
  const { r, g, b } = color;
  const toHex = (value) => {
    const hex = value.toString(16);
    return hex.length === 1 ? "0" + hex : hex;
  };
  return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
};